import { Stream } from '../stream'

type DisposeFn = () => void

// this was not built as class factory since it will lose generic types if it was do so
export class Build<V = any, E = any, C = any> extends Stream<V, E, C> {
    constructor(protected onSubscription: (stream: Stream<V, E, C>) => DisposeFn) {
        super()
    }

    connect() {
        super.connect()
        this.dispose = this.onSubscription(this)
    }

    disconnect() {
        super.disconnect()
        this.dispose()
    }

    protected dispose: DisposeFn = () => {}
}

export const build = <V = any, E = any, C = any>(fn: (stream: Stream<V, E, C>) => DisposeFn): Stream<V, E, C> =>
    new Build(fn)
